import { IconButton } from '../IconButton';

export const ModalHeader = ({ title, subtitle, onClose, disabled }) => (
  <div className="flex items-start justify-between gap-4 pt-5 px-5 pb-4">
    <div className="flex flex-col gap-1 min-w-0">
      <span className="text-base-1000 font-semibold text-[22px]/[28px]">
        {title}
      </span>
      <span className="text-base-800 text-[16px]/[24px]">{subtitle}</span>
    </div>
    <IconButton
      buttonProps={{
        className: 'w-8 h-8 shrink-0 !rounded-full !bg-base-700',
        'aria-label': 'Close',
        disabled,
        onClick: onClose,
      }}
      iconProps={{ name: 'cross', className: 'h-5' }}
    />
  </div>
);
